import { Component, OnInit } from '@angular/core';
import { CommonService } from '@tech-services/common.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { AppConfig } from '@tech-utils/app-config.service';

@Component({
  selector: 'tech-upnavbar',
  templateUrl: './upnavbar.component.html',
  styleUrls: ['./upnavbar.component.scss'],
})
export class UpnavbarComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  public logowhiteUrl =
    './assets/img/' +
    localStorage.getItem('ThemeImg') +
    '/WealthRules-265px.png';
  public showOptions: boolean = true;
  public Notifications: any;
  public zeroNotifications: boolean = false;

  constructor(public commonService: CommonService, private router: Router) {}

  ngOnInit() {
    this.commonService.isMovil$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: boolean) => {
        this.logowhiteUrl = data
          ? './assets/img/' + localStorage.getItem('ThemeImg') + '/WR_white.png'
          : './assets/img/' +
            localStorage.getItem('ThemeImg') +
            '/WealthRules-White-530px.png';
      });

    this.commonService.showMenu$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: boolean) => {
        this.showOptions = data;
      });

    this.commonService.clientDataInitial$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.commonService.notificationUpNavSource.next(result.Notifications);
      });

    this.commonService.notificationUpNav$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.Notifications = res >= 100 ? '+99' : res;
        this.zeroNotifications = res == 0 ? true : false;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  goRiskProfile() {
    this.router.navigate(['/riskprofile']);
  }

  goToProfilePortfolio() {
    this.commonService.showMenuSource.next(true);
    this.router.navigate(['/portfolios']);
  }
  goaccountsettings() {
    this.router.navigate(['/accountsettings']);
  }
}
